import DropdownMenu from "../../../../../../../common/Menu/DropdownMenu/DropdownMenu";
import DatePeriodControlled from "../../../../../../../common/Inputs/DatePeriodControlled/DatePeriodControlled";


import CommentInput from "../../../../../../../common/Inputs/CommentInput/CommentInput";
import SingleUploader from "../../../../../../../common/SingleUploader/SingleUploader";

import RequestInputInArray from "../../../../../../../common/Inputs/RequestInputInArray/RequestInputInArray";

import {
    getdisabilityChildrenThunkAction,
} from "../../../../../../../../redux/actions/Requests/Child-disability/thunk/getdisabilityChildren.thunk.action";
import {
    getPeriodsForChildDisabilityThunkAction,
} from "../../../../../../../../redux/actions/Requests/Child-disability/thunk/getPeriodsForChildDisability.thunk.action";
import {
    getSecondParentStatuses,
} from "../../../../../../../../redux/actions/Requests/Child-disability/thunk/getSecondParentStatuses.thunk.action";
import {
    addExtraVacationInformationCurrentRequest,
} from "../../../../../../../../redux/actions/Requests/currentRequestControls/addBloodDonationInformation.currentRequest";
import {
    datepickerSelectCurrentRequest,
} from "../../../../../../../../redux/actions/Requests/currentRequestControls/datepickerSelect.currentRequest";
import {
    getEmployeeWorkDaysThunkAction,
} from "../../../../../../../../redux/actions/Requests/Child-disability/thunk/getEmployeeWorkDays.thunk.action";
import {
    addObjKeyYoArrayAction,
} from "../../../../../../../../redux/actions/Requests/currentRequestControls/addObjKeyYoArray.action";
import {
    deleteAttachmentThunkAction,
} from "../../../../../../../../redux/actions/Requests/Attachments/thunk/deleteAttachment.thunk.action";
import {
    getParentFullNameThunkAction,
} from "../../../../../../../../redux/actions/Requests/ParentalLeave/thunk/getParentFullName.thunk.action";

import {
    addBasicInputHandlerCurrentRequest,
} from "../../../../../../../../redux/actions/Requests/currentRequestControls/addBasicInputHandler.currentRequest";

import {
    getCurrentRequestAction,
} from "../../../../../../../../redux/actions/Requests/CurrentRequest/getCurrentRequest.action";
import {
    validationControlCurrentRequest,
} from "../../../../../../../../redux/actions/Requests/currentRequestControls/validationControl.currentRequest";


import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment/moment";
import "./ChildDisability.scss";
import { useSearchParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { element } from "prop-types";

const ChildDisability = ({
    currentRequest,
    setRequestState,
    commentHandler,
}) => {
    const [searchParams] = useSearchParams();
    const queryId = searchParams.get("id");
    const dispatch = useDispatch();
    const disabilityPeriods = useSelector(state => state.requests.disabilityPeriods);
    const parentStatuses = useSelector(state => state.requests.parentStatuses);
    const disabilitiesChildren = useSelector(state => state.requests.disabilitiesChildren);
    const requestAttachments = useSelector(state => state.requests.requestAttachments);
    const [input, setInput] = useState({
        tabNum:
            currentRequest?.disabledChildCare?.secondParent?.tabNumber ? currentRequest?.disabledChildCare?.secondParent?.tabNumber :  "",
        errorMessage: "",
        loading: false,
    });
    const [days , setDays] = useState({
        loading: false,
        count: null,
        error: null,
    });

    function selectDropdown(event, element, field) {
        if (field === "period" || field === "secondParentStatus") {
            if(field === "period") {
                dispatch(addExtraVacationInformationCurrentRequest({
                    stateProperty:  "disabledChildCare",
                    field: "allowsMultipleDateRanges",
                    value: element.allowsMultipleDateRanges,
                }));
            }
            if(field === "period" && element.allowsMultipleDateRanges === false) {
                dispatch(addBasicInputHandlerCurrentRequest({ field: "periods", value: [currentRequest?.periods[0]] }));
            }

            if(field === "secondParentStatus" && element.id === 2) {
                const tempAttach = requestAttachments?.find((el) => el.subDocumentType === 10 );
                dispatch(
                    validationControlCurrentRequest(
                        { object: "disabledChildCare", innerKey: "SecondParentEmploymentCertificateNotRequired" },
                        true,
                        "object",
                    ),
                );
                // if (tempAttach) {
                //     dispatch(deleteAttachmentThunkAction(
                //         {attachId: tempAttach.id, requestId: currentRequest.uid}
                //     ));
                //
                // }

            }
            if (field === "secondParentStatus" && element.id !== 2) {
                const temp = {...currentRequest};
                delete temp.disabledChildCare.secondParent;
                setInput(prev => ({
                    ...prev,
                    tabNum: "",
                    errorMessage: "",
                }));
                dispatch(getCurrentRequestAction(temp));
            }
            dispatch(addExtraVacationInformationCurrentRequest({
                stateProperty: currentRequest && currentRequest.leaveReasonId === 34 ? "disabledChildCare" : "bloodDonationData",
                field: field,
                value: element.id,
            }));
        } else {
            dispatch(addExtraVacationInformationCurrentRequest({
                stateProperty: currentRequest && currentRequest.leaveReasonId === 34 ? "disabledChildCare" : "bloodDonationData",
                field: field,
                value: element,
            }));
        }
    }

    function changeHandler(date, index, field) {
        dispatch(datepickerSelectCurrentRequest({
            date: moment(date).format("YYYY-MM-DD"),
            index,
            field,
        }));
        if (currentRequest && currentRequest.periods[index].dateFrom && currentRequest.periods[index].dateTo) {
            setDays((prevState) => {
                return   { ...prevState,
                    loading:true,
                    error: null,
                };
            }
            );
            dispatch(addObjKeyYoArrayAction({
                objKeyName: "loader",
                arrayKey: null,
                objKey: true,
                elementIndex: index,
                fieldArray: "periods",
            }));
            dispatch(addObjKeyYoArrayAction({
                objKeyName: "error",
                arrayKey: null,
                objKey: null,
                elementIndex: index,
                fieldArray: "periods",
            }));
            // dispatch(getEmployeeWorkDaysThunkAction({
            //     dateFrom: currentRequest.periods[index].dateFrom,
            //     dateTo: currentRequest.periods[index].dateTo,
            //     index,
            //     field: "periods" }));

            dispatch(getEmployeeWorkDaysThunkAction({
                periods: currentRequest?.periods.filter(element => element.dateFrom && element.dateTo),
                index: index,
                setDays: setDays,
                field: "periods" }));
        }
    }
    function checkboxHandler(event) {
        if(!event.target.checked) {
            console.log("start true");
            const tempAttach = requestAttachments?.find((el) => el.subDocumentType === 10 );
            // if (tempAttach) {
            //     dispatch(deleteAttachmentThunkAction(
            //         {attachId: tempAttach.id, requestId: currentRequest.uid}
            //     ));
            // }
            const temp = {...currentRequest};
            delete temp.disabledChildCare.secondParentStatus;
            delete temp.disabledChildCare.secondParent;
            setInput(prev => ({
                ...prev,
                tabNum: "",
                errorMessage: "",
            }));
            dispatch(getCurrentRequestAction(temp));
            dispatch(
                validationControlCurrentRequest(
                    { object: "disabledChildCare", innerKey: "secondParentStatus" },
                    true,
                    "object",
                ),
            );  dispatch(
                validationControlCurrentRequest(
                    { object: "disabledChildCare", innerKey: "secondParent" },
                    true,
                    "object",
                ),
            );
            dispatch(
                validationControlCurrentRequest(
                    { object: "disabledChildCare", innerKey: "SecondParentEmploymentCertificateNotRequired" },
                    true,
                    "object",
                ),
            );


        }else {
            dispatch(
                validationControlCurrentRequest(
                    { object: "disabledChildCare", innerKey: "ParentalLeaveAvailable" },
                    true,
                    "object",
                ),
            );

            // const tempAttach = requestAttachments?.find((el) => el.subDocumentType === 5 );
            // if (tempAttach) {
            //     dispatch(deleteAttachmentThunkAction(
            //         {attachId: tempAttach.id, requestId: currentRequest.uid}
            //     ));
            // }
        }

        dispatch(addExtraVacationInformationCurrentRequest({
            stateProperty: "disabledChildCare",
            field: "isSecondParentWorkCertificateNotRequired",
            value: event.target.checked,
        }));

        // dispatch(addExtraVacationInformationCurrentRequest({
        //     stateProperty: "disabledChildCare",
        //     field: "secondParentStatus",
        //     value: null,
        // }));
    }


    function searchParent(event ) {
        dispatch(
            validationControlCurrentRequest(
                { object: "disabledChildCare", innerKey: "secondParent" },
                true,
                "object",
            ),
        );
        if (event.target.value.length === 8) {
            setInput(prev => ({
                ...prev,
                tabNum: event.target.value,
                errorMessage: "",
                loading: true,
            }));

            dispatch(getParentFullNameThunkAction({
                index: null,
                tabNumber: event.target.value,
                field: "tabNumber",
                currentRequest,
                setInput,
                input,

            }));
        }else{

            setInput(prev => ({
                ...prev,
                tabNum: event.target.value,
                errorMessage: "", // сброс ошибки при изменении
            }));

        }
    }

    function deleteTabNumHandler() {
        const temp = {...currentRequest};
        delete temp.disabledChildCare.secondParent;
        setInput(prev => ({
            ...prev,
            tabNum: "",
            errorMessage: "",
            loading: false,
        }));
    }

    useEffect(() => {
        dispatch(getdisabilityChildrenThunkAction());
        dispatch(getPeriodsForChildDisabilityThunkAction());
        dispatch(getSecondParentStatuses());
        if(queryId) {

            // currentRequest.periods.forEach((period, index) => {
            if(currentRequest && currentRequest.periods.length ) {
                // dispatch(addObjKeyYoArrayAction({
                //     objKeyName: "loader",
                //     arrayKey: null,
                //     objKey: true,
                //     elementIndex: index,
                //     fieldArray: "periods",
                // }));
                // dispatch(addObjKeyYoArrayAction({
                //     objKeyName: "error",
                //     arrayKey: null,
                //     objKey: null,
                //     elementIndex: index,
                //     fieldArray: "periods",
                // }));
                dispatch(getEmployeeWorkDaysThunkAction({
                    periods: currentRequest?.periods,
                    // index: index,
                    setDays: setDays,
                    field: "periods" }));

            }
            // });
        }
        return () => {
        };
    }, []);


    const prevLengthRef = useRef(0);

    useEffect(() => {
        const periods = currentRequest?.periods;
        const currentLength = periods?.length || 0;
        const prevLength = prevLengthRef.current;

        // Проверяем условия:
        // 1. Есть периоды
        // 2. Длина уменьшилась
        // 3. Новая длина > 0
        if (periods && currentLength < prevLength && currentLength > 0) {
            // Также можно проверить, что все периоды заполнены
            const allPeriodsComplete = periods.every(
                period => period.dateFrom && period.dateTo
            );

            if (allPeriodsComplete) {
                dispatch(getEmployeeWorkDaysThunkAction({
                    periods: periods,
                    setDays: setDays,
                    field: "periods",
                }));
            }
        }

        // Обновляем ref для следующего сравнения
        prevLengthRef.current = currentLength;
    }, [currentRequest?.periods?.length, currentRequest?.periods]);


    return (
        <>
            <DropdownMenu
                visibleIndex={"100"}
                uid={currentRequest && currentRequest.uid}
                fieldId={"autoCard"}
                fieldName={"fullName"}
                fieldStateProperty={"autoCard"}
                currentRequest={currentRequest && currentRequest.disabledChildCare?.child}
                styleName={"reason"}
                label={<>ФИО ребенка <span className="required_text"> *</span></>}
                listOfOptions={disabilitiesChildren}
                stateProperty={"child"}
                isValidKey={
                    currentRequest
                    && currentRequest.isValid
                    && currentRequest.isValid.disabledChildCare?.child
                        ? currentRequest.isValid.disabledChildCare?.child
                        : false}
                selectOptionClick={selectDropdown} />
            <DropdownMenu
                // visibleIndex={"80"}
                uid={currentRequest && currentRequest.uid}
                currentRequest={currentRequest && currentRequest.disabledChildCare}
                styleName={"reason"}
                label={<>Выбор периода для предоставления дней отдыха <span className="required_text"> *</span></>}
                listOfOptions={disabilityPeriods}
                stateProperty={"period"}
                helper={` В дни отдыха по уходу за ребенком-инвалидом включаются только рабочие дни.
    Обращаем внимание: выбор нескольких периодов, за которые предоставляются дни отдыха, доступен только в рамках календарного месяца.
`}
                isValidKey={
                    currentRequest
                    && currentRequest.isValid
                    && currentRequest.isValid.disabledChildCare?.period
                        ? currentRequest.isValid.disabledChildCare?.period
                        : false
                }
                selectOptionClick={selectDropdown} />

            {
                currentRequest &&
                currentRequest.periods &&
                currentRequest.periods.map((period, index) => {
                    return (
                        <DatePeriodControlled
                            // blockPeriod={period}
                            days={days}
                            allowsMultipleDateRanges={currentRequest
                                && currentRequest.disabledChildCare && currentRequest.disabledChildCare.period === 1}
                            withControledInput={true}
                            setRequestState={setRequestState}
                            periodsLength={
                                currentRequest
                                    && currentRequest.periods
                                    && currentRequest.periods.length
                                    ? currentRequest.periods.length
                                    : false
                            }
                            handler={changeHandler}
                            key={uuidv4()}
                            parentStyle={"extra-vacation-days"}
                            period={period}
                            index={index}
                            datesForRange={{
                                minFrom: new Date(),
                                // minTo: new Da ,
                            }}
                            label={
                                {
                                    from: <>Дата начала отдыха <span className="required_text"> *</span></>,
                                    to: <>Дата окончания отдыха <span className="required_text"> *</span></>,
                                }
                            }
                        />

                    );
                })
            }
            {
                currentRequest &&
                currentRequest.periods &&
                currentRequest.periods.length &&
                currentRequest.periods[0].dateFrom && currentRequest.periods[0].dateTo ?
                    <>
                        <div>

                            <label className="custom-checkbox">
                                <input
                                    onChange={(event)=>checkboxHandler(event)}
                                    checked={currentRequest && currentRequest.disabledChildCare?.isSecondParentWorkCertificateNotRequired}
                                    type="checkbox" />
                                <span className="checkmark"></span>
                                Справка с места работы второго родителя не требуется *
                            </label>
                        </div>
                        {
                            currentRequest && currentRequest.disabledChildCare?.isSecondParentWorkCertificateNotRequired ?
                                <>
                                    <DropdownMenu
                                        visibleIndex={"5"}
                                        uid={currentRequest && currentRequest.uid}
                                        currentRequest={currentRequest.disabledChildCare}
                                        styleName={"reason"}
                                        label={<>Сведения о втором родителе <span className="required_text"> *</span></>}
                                        listOfOptions={parentStatuses}
                                        stateProperty={"secondParentStatus"}
                                        isValidKey={
                                            currentRequest
                                            && currentRequest.isValid
                                            && (currentRequest.isValid.disabledChildCare?.secondParentStatus ||
                                                currentRequest.isValid.disabledChildCare?.secondParentStatus === undefined ||
                                                currentRequest.isValid.disabledChildCare?.secondParentStatus === null )
                                                ? currentRequest.isValid.disabledChildCare?.secondParentStatus
                                                : false
                                        }
                                        selectOptionClick={selectDropdown} />
                                    {
                                        currentRequest && currentRequest.disabledChildCare?.secondParentStatus === 2 ?
                                            <div >
                                                <CommentInput
                                                    width={"467px"}
                                                    withDeleteButton={deleteTabNumHandler}
                                                    uploader={true}
                                                    value={
                                                        currentRequest && currentRequest.disabledChildCare && currentRequest.disabledChildCare.secondParent?.tabNumber ?
                                                            currentRequest.disabledChildCare.secondParent?.tabNumber
                                                            : input.tabNum
                                                    }
                                                    basicInput={true}
                                                    // handler={searchParent}
                                                    changeHandler={searchParent}
                                                    maxLength={8}
                                                    stateProperty={"tabNumber"}
                                                    field={"tabNumber"}
                                                    label={ "Табельный номер второго родителя *"}
                                                    errorMessage={
                                                        currentRequest
                                                        && currentRequest.isValid
                                                        && (currentRequest.isValid.disabledChildCare?.secondParent ||
                                                            currentRequest.isValid.disabledChildCare?.secondParent === undefined ||
                                                            currentRequest.isValid.disabledChildCare?.secondParent === null)
                                                            ? false
                                                            : "Обязательное поле"
                                                    }
                                                    parentStyle={"unpaid-practice"}
                                                    letter={300}
                                                />
                                                <div style={{ display: "flex" ,
                                                    flexDirection: "column" ,
                                                    gap: "15px",
                                                    background: "rgba(249, 249, 249, 1)",
                                                    width: "467px",
                                                    padding: "32px 40px",
                                                    borderRadius: "15px",
                                                    boxShadow: "rgba(249, 249, 249, 1) 0px 8px 24px",
                                                    color: "grey",

                                                }}>
                                                    <label
                                                        htmlFor="comment"
                                                        className={"extra-vacation-days-comment__label"}
                                                    >
                                                        ФИО второго родителя
                                                    </label>
                                                    <div >
                                                        {input.loading ? <ClipLoader  size={32} color="#6DCDF6"/> :
                                                            input.errorMessage ? input.errorMessage : currentRequest &&
                                                            currentRequest.disabledChildCare &&
                                                            currentRequest.disabledChildCare.secondParent?.lastName ?
                                                                `${currentRequest.disabledChildCare.secondParent.lastName} ${currentRequest.disabledChildCare.secondParent.firstName} ${currentRequest.disabledChildCare.secondParent.middleName}` : " "}
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    }
                                </>
                                : null
                        }
                        {
                            currentRequest && !currentRequest.disabledChildCare?.isSecondParentWorkCertificateNotRequired ?
                                <SingleUploader
                                    isValidConfirmation={"disabledChildCare"}
                                    label={
                                        "Справка с места работы (службы)" +
                                        " отца (матери, обоих родителей)" +
                                        " ребенка о том, что он (она, они)" +
                                        " не использует отпуск по уходу за ребенком"
                                    }
                                    subType={"ParentalLeaveAvailable"}
                                    subTypeNumber={5}
                                    errorMessage={
                                        currentRequest
                                        && currentRequest.isValid
                                        && (currentRequest.isValid.disabledChildCare?.ParentalLeaveAvailable ||
                                            currentRequest.isValid.disabledChildCare?.ParentalLeaveAvailable === undefined ||
                                            currentRequest.isValid.disabledChildCare?.ParentalLeaveAvailable === null)
                                            ? false
                                            : "Обязательное поле"
                                    }
                                />
                                : null

                        }
                        {
                            currentRequest && (currentRequest.disabledChildCare?.secondParentStatus !== null &&
                                currentRequest.disabledChildCare?.secondParentStatus !== 2
                                && currentRequest.disabledChildCare?.secondParentStatus !== undefined) ?
                                <SingleUploader
                                    isValidConfirmation={"disabledChildCare"}
                                    label={
                                        "Документ подтверждающий что справки с места работы второго родителя не требуется *"
                                    }
                                    subType={"SecondParentEmploymentCertificateNotRequired"}
                                    subTypeNumber={10}
                                    errorMessage={
                                        currentRequest
                                        && currentRequest.isValid
                                        && (currentRequest.isValid.disabledChildCare?.SecondParentEmploymentCertificateNotRequired ||
                                            currentRequest.isValid.disabledChildCare?.SecondParentEmploymentCertificateNotRequired === undefined ||
                                            currentRequest.isValid.disabledChildCare?.SecondParentEmploymentCertificateNotRequired === null)
                                            ? false
                                            : "Обязательное поле"
                                    }
                                />
                                : null
                        }


                        <SingleUploader
                            isValidConfirmation={"disabledChildCare"}
                            label={
                                "Копия свидетельства о рождении (усыновлении) ребенка (детей) *"
                            }
                            subType={"BirthOrGuardianshipCertificate"}
                            subTypeNumber={2}
                            errorMessage={
                                currentRequest
                                && currentRequest.isValid
                                && (currentRequest.isValid.disabledChildCare?.BirthOrGuardianshipCertificate ||
                                    currentRequest.isValid.disabledChildCare?.BirthOrGuardianshipCertificate === undefined ||
                                    currentRequest.isValid.disabledChildCare?.BirthOrGuardianshipCertificate === null)
                                    ? false
                                    : "Обязательное поле"
                            }
                        />
                        <SingleUploader
                            isValidConfirmation={"disabledChildCare"}
                            label={
                                "Справка, подтверждающая факт установления инвалидности," +
                                " выданная бюро (главным бюро, Федеральным бюро)" +
                                " медико-социальной экспертизы *"}
                            subType={"DisabilityConfirmation"}
                            subTypeNumber={3}
                            errorMessage={
                                currentRequest
                                && currentRequest.isValid
                                && (currentRequest.isValid.disabledChildCare?.DisabilityConfirmation ||
                                    currentRequest.isValid.disabledChildCare?.DisabilityConfirmation === undefined ||
                                    currentRequest.isValid.disabledChildCare?.DisabilityConfirmation === null)
                                    ? false
                                    : "Обязательное поле"
                            }
                        />
                        <SingleUploader
                            isValidConfirmation={"disabledChildCare"}
                            label={
                                "Документ о месте жительства" +
                                " (пребывания или фактического проживания)" +
                                " ребенка-инвалида (например," +
                                " у 14-летнего ребенка это паспорт с отметкой о регистрации )*"
                            }
                            subType={"PlaceResidenceConfirmation"}
                            subTypeNumber={4}
                            errorMessage={
                                currentRequest
                                && currentRequest.isValid
                                && (currentRequest.isValid.disabledChildCare?.PlaceResidenceConfirmation ||
                                    currentRequest.isValid.disabledChildCare?.PlaceResidenceConfirmation === undefined ||
                                    currentRequest.isValid.disabledChildCare?.PlaceResidenceConfirmation === null)
                                    ? false
                                    : "Обязательное поле"
                            }
                        />
                    </>
                    :null
            }

            <CommentInput
                maxLength={255}
                value={currentRequest && currentRequest.employeeComment}
                stateProperty={"employeeComment"}
                changeHandler={commentHandler}
                label={"Комментарий"}
                parentStyle={"unplanned-vacation"}
            />

        </>
    );
};

export default ChildDisability;
